import React from "react";
import { Text, View, FlatList, Image } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { CreateResponsiveStyle } from "rn-responsive-styles";

const topGiftersData = [
  { id: "1", name: "User1", gifts: 100 },
  { id: "2", name: "User2", gifts: 75 },
  { id: "3", name: "User3", gifts: 50 },
  { id: "4", name: "User4", gifts: 40 },
];

const AudiencePollAndTopGifter = () => {
  const styles = useStyles();
  const youProgress = 60;
  const nameProgress = 45;
  const staticName = "PlayerXYZ";
  const votes = "1256";
  const remainingTime = "2:15";

  const renderGifterItem = ({ item }) => (
    <View style={styles.userItem}>
      <View style={styles.profileContainer}>
        <Image
          source={{ uri: "https://via.placeholder.com/24" }}
          style={styles.profileIcon}
        />
        <Text style={styles.profileNumber}>{item.gifts}</Text>
      </View>
      <View style={styles.nameSection}>
        <Text style={styles.gifterName}>{item.name}</Text>
        <Text style={styles.gifterGifts}>{item.gifts} gifts</Text>
      </View>
    </View>
  );

  return (
    <>
    <View style={styles.container}>
      <View style={styles.mainSection}>
        <View style={styles.sectionContent}>
          <Text style={styles.sectionTitle}>Audience Poll</Text>
          <Text style={styles.youText}>You</Text>
          <View style={styles.progressContainer}>
            <View style={styles.progressBar}>
              <View
                style={[
                  styles.progressFill,
                  { width: `${youProgress}%` },
                  styles.blueFill,
                ]}
              />
            </View>
            <Text style={styles.progressText}>{youProgress}% Complete</Text>
          </View>
          <Text style={styles.nameText}>{staticName}</Text>
          <View style={styles.progressContainer}>
            <View style={styles.progressBar}>
              <View
                style={[
                  styles.progressFill,
                  { width: `${nameProgress}%` },
                  styles.redFill,
                ]}
              />
            </View>
            <Text style={styles.progressText}>{nameProgress}% Complete</Text>
          </View>
          <View style={styles.bottomText}>
            <Text style={styles.bottomLabel}>{votes} votes</Text>
            <Text style={styles.bottomLabel}>{remainingTime} remaining</Text>
          </View>
        </View>
      </View>
      <View style={styles.mainSection}>
        <View style={styles.sectionContent}>
          <Text style={styles.sectionTitle}>Top Gifters</Text>
          <View style={styles.giftersContainer}>
            <FlatList
              data={topGiftersData}
              renderItem={renderGifterItem}
              keyExtractor={(item) => item.id}
              numColumns={2}
              columnWrapperStyle={styles.columnWrapper}
              style={styles.giftersList}
              contentContainerStyle={styles.giftersContent}
            />
          </View>
        </View>
      </View>
      <View style={styles.overlay}>
        <Text style={[styles.overlayText, { fontSize: 24 }]}>
          Audience Poll & Top Gifter
        </Text>
        <Text style={[styles.overlayText, { fontSize: 32, color: "#FACC15" }]}>
          Coming Soon
        </Text>
      </View>
    </View></>

  );
};

export default AudiencePollAndTopGifter;

const useStyles = CreateResponsiveStyle({
  container: {
    flexDirection: "row",
    height: 150,
    justifyContent: "space-between",
    backgroundColor: AppColors.black_18151b,
    borderRadius: 12,
    gap: 12,
    width: "100%",
    position: "relative",
    overflow: "hidden",
    marginBottom : 20
  },
  mainSection: {
    flex: 1,
    minWidth: 0,
  },
  sectionContent: {
    backgroundColor: AppColors.grayColor_282828,
    borderRadius: 8,
    padding: 10,
    height: "100%",
    justifyContent: "space-between",
    flex: 1,
    position: "relative",
  },
  sectionTitle: {
    color: AppColors.purple_C084FC,
    fontSize: 14,
    fontWeight: "bold",
    position: "absolute",
    top: 8,
    left: 10,
  },
  youText: {
    color: "#1E90FF",
    fontSize: 12,
    marginBottom: 4,
    marginTop: 20,
  },
  nameText: {
    color: "#FF0000",
    fontSize: 12,
    marginBottom: 4,
  },
  progressContainer: {
    width: "100%",
    marginBottom: 4,
  },
  progressBar: {
    width: "100%",
    height: 12,
    backgroundColor: AppColors.grayColor_282828,
    borderRadius: 5,
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    borderRadius: 5,
  },
  blueFill: {
    backgroundColor: "#1E90FF",
  },
  redFill: {
    backgroundColor: "#FF0000",
  },
  progressText: {
    color: AppColors.white_C3C3C3,
    fontSize: 10,
    textAlign: "right",
    width: "100%",
    marginTop: 2,
  },
  bottomText: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    gap: 10,
  },
  bottomLabel: {
    color: AppColors.white,
    fontSize: 10,
    textAlign: "center",
  },
  giftersContainer: {
    flex: 1,
    width: "100%",
    paddingTop: 20,
  },
  giftersList: {
    flex: 1,
    width: "100%",
  },
  giftersContent: {
    paddingVertical: 5,
  },
  columnWrapper: {
    justifyContent: "space-between",
  },
  userItem: {
    flex: 1,
    alignItems: "center",
    paddingVertical: 4,
    flexDirection: "row",
  },
  nameSection: {
    flexDirection: "column",
    marginLeft: 12,
  },
  profileContainer: {
    position: "relative",
    marginBottom: 4,
  },
  profileIcon: {
    width: 36,
    height: 36,
    borderRadius: 12,
    backgroundColor: "#ccc",
  },
  profileNumber: {
    position: "absolute",
    top: -4,
    right: -4,
    backgroundColor: AppColors.purple_6D28D9,
    color: AppColors.white,
    fontSize: 10,
    width: 16,
    height: 16,
    textAlign: "center",
    borderRadius: 8,
  },
  gifterName: {
    color: AppColors.white,
    fontSize: 12,
    textAlign: "left",
  },
  gifterGifts: {
    color: AppColors.white_C3C3C3,
    fontSize: 10,
    textAlign: "left",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(14px)"
  },

  overlayText: {
    color: AppColors.white,
    fontWeight: "bold",
    textAlign: "center",
  },
});
